import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

// Define the menu structure
const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
        // submenu: [
        //     { id: 11, title: 'Home', link: '/' },
        //     { id: 12, title: 'Software Company', link: '/home_software_company' },
        //     { id: 13, title: 'Business Consulting', link: '/home_business_consulting' }
        // ]
    },
    // {
    //     id: 3,
    //     title: 'Pages',
    //     link: '/',
    //     submenu: [
    //         { id: 31, title: 'Case Studies', link: '/portfolio' },
    //         { id: 3222, title: 'Our Pricing', link: '/pricing' },
    //         { id: 322, title: 'About Us', link: '/about' },
    //         { id: 345, title: 'Team', link: '/team' },
    //         { id: 3454, title: 'Team Details', link: '/team-single/Atticus-Sterling' }
    //     ]
    // },
    {
        id: 2,
        title: 'About Us',
        link: '/about',
    },
    {
        id: 4,
        title: 'Services',
        link: '/service',
        submenu: [
            { id: 41, title: 'Service', link: '/service' },
            { id: 42, title: 'Service Details', link: '/service-single/IT-Management-Services' }
        ]
    },
    {
        id: 5,
        title: 'Portfolio',
        link: '/portfolio',
        submenu: [
            { id: 51, title: 'Portfolio', link: '/portfolio' },
            { id: 52, title: 'Portfolio Details', link: '/portfolio_details/Explore-Our-IT-Solutions' }
        ]
    },
    {
        id: 6,
        title: 'Blog',
        link: '/blog',
        submenu: [
            { id: 61, title: 'Blog', link: '/blog' },
            { id: 62, title: 'Blog Details', link: '/blog-single/How-Our-Software-Solutions-Drive-Insights.' }
        ]
    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    }
]

const MobileMenu = ({ setMobailState }) => {

    // State to track which submenu is open
    const [openId, setOpenId] = useState(0);

    // Common click handler to scroll and close menu
    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMobailState(false);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, index) => (
                <ListItem className={item.id === openId ? 'active' : ''} key={index}>
                    
                    {/* If item has submenu and its link is '/', allow toggle behavior */}
                    {item.submenu && item.link === '/' ? (
                        <Fragment>
                            <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                {item.title}
                                <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                            </p>

                            {/* Submenu collapse animation */}
                            <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                <List className="subMenu">
                                    {item.submenu.map((submenu, i) => (
                                        <ListItem key={i}>
                                            <Link onClick={ClickHandler} to={submenu.link}>
                                                {submenu.title}
                                            </Link>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </Fragment>
                    ) : (
                        // If no submenu or link is not '/', direct navigation
                        <Link onClick={ClickHandler} to={item.link}>
                            {item.title}
                        </Link>
                    )}
                </ListItem>
            ))}
        </ul>
    )
}

export default MobileMenu;
